// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CbJK","select":"styles_select__1gApe"};